export const storageTransfer = {
	warningNotifications: {
		productAlreadyOnList: "¡Este producto ya fue agregado a la lista!",
		originAndDestinyStorageAreTheSame:
			"¡El inventario de salida no puede ser el mismo inventario de destino!",
		notPossibleToTransferToMultipleStorages:
			"¡No es posible agregar a la lista productos con inventarios de destino diferentes!",
	},
	title: "Transferir productos del inventario {{storageName}}",
	cancel: "Cancelar",
	finish: "Concluir",
	feedbackModal: {
		notFound: "No encontrado",
		sheet: {
			filename: "transferencia-inventario",
			title: "Transferencia del inventario {{fromStorageName}} para {{toStorageName}}",
			columns: {
				product: "Producto",
				quantity: "Cantidad",
				ube: "Unidad",
			},
		},
		close: "Cerrar",
		cancel: "Cancelar",
		importOnlyAssociated: "Importar solo asociados",
		associateAndProducts: "Asociar productos e importar",
		downloadExcell: "Descargar en Excel",
		messages: {
			loading: {
				title: "Transfiriendo Productos",
				subtitle: "Aguarde, estamos transfiriendo los productos",
			},
			error: {
				title: "Ups... Algo no salió como planeado.",
				subtitle:
					"No pudimos realizar la transferencia de los productos.\nIntente nuevamente más tarde.",
			},
			needPlaceAtivation: {
				title: "Ups... Algo no salió como planeado.",
				subtitle: "¿Desea guardar el informe de transferencia?",
			},
			success: {
				title: "Transferencia realizada con éxito",
				subtitle: "¿Desea guardar el informe de transferencia?",
			},
		},
		wasntPossibleToTransferDueToNotAssociatedProducts:
			"Ups... No fue posible realizar la transferencia. Algunos productos no están asociados en el local de destino. Asocie los siguientes productos para continuar:",
		title: "Informe de transferencia",
		transferPrint: {
			printReport: "Imprimir informe",
			pdf: {
				proofOfTransfer: "Comprobante de transferencia",
				message:
					'Este documento comprueba la transferencia de productos del Inventario "{{fromStorage}}" para el inventario "{{toStorage}}" en {{transferDateString}} hecha por ZigPay. Los productos transferidos están en la siguiente lista:',
				storageResponsible: "Responsable por el inventario destino",
			},
		},
	},
	transferProductForm: {
		form: {
			validation: {
				maxStorageCountIs: "Cantidad máxima en inventario es {{productMaxCountString}}",
				missingField: "Campo obligatorio",
				invalidQuantity: "Cantidad inválida",
			},
			storageTypes: {
				local: "Inventario local",
				central: "Inventario general",
			},
			placeholder: {
				product: "Busque por el producto",
				storage: "Inventario de destino",
			},
			label: {
				storageType: "Transferir para:",
				storage: "Inventario de destino",
				product: "Busque por el producto",
				quantity: "Cantidad",
			},
			submit: "Agregar",
		},
	},
	table: {
		columns: {
			name: "producto",
			toStorage: "Inventario destino",
			count: "cantidad",
			unitcost: "costo unitario",
			totalcost: "costo total",
			action: "acción",
		},
	},
};
